import { render } from "./EnglishClasses.vue?vue&type=template&id=7492f041&scoped=true"
import script from "./EnglishClasses.vue?vue&type=script&lang=js"
export * from "./EnglishClasses.vue?vue&type=script&lang=js"

import "./EnglishClasses.vue?vue&type=style&index=0&id=7492f041&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7492f041"]])

export default __exports__